import type { FC } from 'react';
import { IconButton } from '@carbon/react';
import { Maximize } from '@carbon/icons-react';

import type { LocalTrack } from '@maestra/core/stores/localPlayerStore';
import { usePlayerLocal } from '../../logica/player/usePlayerLocal';
import { BarraDoPlayer } from '../padroes/BarraDoPlayer';
import styles from './Casca.module.scss';

// O PLAYER GLOBAL — a barra do rodapé (`padroes/BarraDoPlayer`, o mesmo desenho da playlist
// compartilhada) ligada ao áudio da casca: a faixa volta para a tela dela, e há tela cheia quando a
// faixa tem. A lógica do <audio> mora em src/logica/player.

export interface PropsDoPlayer {
  faixas: LocalTrack[];
  atual: string;
  trocar: (id: string) => void;
  abrirFaixa: () => void;
  abrirVisualizacao: (url: string) => void;
  fechar: () => void;
}

export const Player: FC<PropsDoPlayer> = ({ faixas, atual, trocar, abrirFaixa, abrirVisualizacao, fechar }) => {
  const p = usePlayerLocal(faixas, atual, trocar);
  if (!p.faixa) return null;
  const faixa = p.faixa;
  const onde = faixa.onde ?? 'Músicas';

  return (
    <BarraDoPlayer
      className={p.escondido ? `${styles.player} ${styles.playerEscondido}` : styles.player}
      titulo={faixa.title}
      apoio={faixa.subtitle}
      abrirFaixa={{ href: faixa.href ?? '#', rotulo: `Abrir ${faixa.title} em ${onde}`, abrir: abrirFaixa }}
      tocando={p.tocando}
      tocavel={p.tocavel}
      varias={p.varias}
      tempo={p.tempo}
      duracao={p.duracao}
      mudo={p.mudo}
      alternar={p.alternar}
      anterior={p.anterior}
      proxima={p.proxima}
      irPara={p.irPara}
      alternarMudo={p.alternarMudo}
      extras={faixa.fullViewUrl && (
        <IconButton kind='ghost' size='md' label='Abrir em tela cheia' onClick={() => abrirVisualizacao(faixa.fullViewUrl!)}>
          <Maximize />
        </IconButton>
      )}
      fechar={fechar}
    >
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <audio {...p.audio} />
    </BarraDoPlayer>
  );
};
